import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

const { innerWidth: width, innerHeight: height } = window;

const WarehouseOrderStatusReportDoneStore = () => {
  const navigate = useNavigate(); 

  const location = useLocation();
  const { data } = location.state || {}; // Fallback to prevent undefined errors

 
  

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div className="cursor-pointer">
        <span>{rowData?.invoiceNo}</span>
      </div>
    );
  };

  const RenderTabView = (data) => {
    // Get all unique statuses from all orders
    const statusColumns = [
      ...new Set(
        data?.flatMap((item) =>
          item?.orderStatusList?.map((statusItem) => statusItem.status),
        ),
      ),
    ];

    return (
      <DataTable
        showGridlines
        value={data}
        paginator
        rows={100}
        rowsPerPageOptions={[50, 100]}
        stripedRows
        scrollable
        scrollHeight={height - 280}
         
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) => options.rowIndex + 1}
        />
         
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "120px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        />

        <Column field="count" header="Total Garment" />

        {statusColumns.map((status) => (
          <Column
            key={status}
            header={status
              .replace(/_/g, " ")
              .replace("SENT TO WARE HOUSE", "RECEIVED")}
            style={{ minWidth: "180px" }}
            body={(rowData) => {
              const statusData = rowData?.orderStatusList?.find(
                (item) => item.status === status,
              );

              return <span>{statusData?.count ?? 0}</span>;
            }}
          />
        ))}
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/WarehouseOrderStatusReport")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Order Status Done Report
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-1 ">
        <div className="flex-1">
          <div className=" flex-1">
            {data.length > 0 ? (
              <>
                <div className="scroll-bar mb-2 mt-4">
                  <div className="mx-4 report-table">
                    <div className="tab-view-table">{RenderTabView(data)}</div>
                  </div>
                </div>
              </>
            ) : data.length === 0 ? (
              <div className="flex-1 flex flex-column justify-content-center align-items-center">
                <p className="text-3xl font-Bold">No Tag Found</p>
              </div>
            ) : (
              <div className="flex-1 flex flex-column justify-content-center align-items-center">
                <p className="text-3xl font-Bold">Tag List is Loading</p>
              </div>
            )}
            <div> 
            </div>
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarehouseOrderStatusReportDoneStore;
